import { InsightType } from 'lib/apis/entity/insight';
import HousePricesStat2x from './housePricesStat2x';
import HousePricesStat3x from './housePricesStat3x';
import HousePricesStat4x from './housePricesStat4x';

type Props = {
  marketStat: InsightType.Stat;
};

const HousePricesStat = ({ marketStat }: Props) => {
  if (marketStat.content.length === 2) {
    return <HousePricesStat2x marketStat={marketStat} />;
  }
  if (marketStat.content.length === 3) {
    return <HousePricesStat3x marketStat={marketStat} />;
  }
  if (marketStat.content.length === 4) {
    return <HousePricesStat4x marketStat={marketStat} />;
  }
  return <></>;
};

export default HousePricesStat;
